import { useContext, useState } from "react";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";

import { C, themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { VideoContext } from "../../VideoContext";

import S from "./_styles.module.scss";

export default function QuizReviewQuestions() {
  const { quiz, openFeedbackModal } = useContext(VideoContext);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(
    () => quiz.assessment?.questionsData?.map((_, i) => i) || []
  );

  return (
    <Accordion
      multiple
      activeIndex={activeQuestionIndex}
      onTabChange={e => setActiveQuestionIndex(e.index)}
      expandIcon={<i className="pi pi-angle-left"></i>}
      collapseIcon={<i className="pi pi-angle-down"></i>}
      aria-label="Quiz questions"
    >
      {quiz.assessment?.questionsData?.map((question, index) => (
        <AccordionTab
          key={question.questionId}
          headerTemplate={
            <QuestionResultHeaderTemplate isCorrect={question.isCorrect} index={index} />
          }
          pt={{
            headerAction: {
              className: "flex-row-reverse",
              href: null,
            },
            content: {
              className: S.promptWrapper,
            },
          }}
        >
          <p className="body-lg">{question.questionText}</p>
          <div className="flex flex-col gap-5">
            <div className="flex justify-between gap-5">
              <div className="flex flex-col flex-1 gap-1.5">
                <span className="body-sm text-surface-400">User answer</span>
                <span>{question.userAnswerText}</span>
                <span
                  className={C(
                    "body-sm",
                    question.isCorrect ? themeClasses.textPrimaryDarker : themeClasses.textSecondary
                  )}
                >
                  {question.feedback}
                </span>
              </div>
              <div className="flex flex-col flex-1 gap-1.5">
                <span className="body-sm text-surface-400">Correct answer</span>
                <span>{question.correctAnswerText}</span>
              </div>
            </div>
          </div>
          <div className="self-end">
            <Button link size="small" className="body-xs" onClick={openFeedbackModal}>
              Provide question feedback
            </Button>
          </div>
        </AccordionTab>
      ))}
    </Accordion>
  );
}

const QuestionResultHeaderTemplate = props => {
  const { isCorrect, index } = props;
  return (
    <div className={S.reviewQuestionHeader}>
      <i className={C("flex-none", isCorrect ? "pi-sj-pass" : "pi-sj-fail")}></i>
      <h4 className="atlas-h5">{`Question ${index + 1}`}</h4>
    </div>
  );
};
